import React, { FC, useState } from 'react';
import Term from '@components/profile/modals/terms/term';
import TermsVO from '@domain/vo/terms/TermsVO';
import { V2RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const getInitialState = (status = false, length = 3) => {
  return Array.from({ length }, () => status);
};

interface NHISTermListProps {
  termList: TermsVO[];
  checkStatus: boolean[];
  onCheck: (args: { idx: number }) => void;
}

const NHISTermList: FC<NHISTermListProps> = ({ termList, checkStatus, onCheck }) => {
  const [openStatus, setOpenStatus] = useState(getInitialState());
  const getOpenStatus = (status: boolean[]) => status.every(() => false);
  const onOpen = ({ idx }: { idx: number }) => {
    const postOpenStatus = getInitialState(getOpenStatus(openStatus));

    postOpenStatus[idx] = !openStatus[idx];
    setOpenStatus(postOpenStatus);
  };

  return (
    <>
      {termList.map((term, idx) => (
        <div key={term.sn} className={cx('termsWrap')}>
          <Term
            termType={'LINK'}
            href={V2RouteUrl.TERMS_NHIS}
            isChecked={checkStatus[idx]}
            {...term}
            onClick={() => onCheck({ idx })}
            isOpen={openStatus[idx]}
            onOpen={() => onOpen({ idx })}
          />
        </div>
      ))}
    </>
  );
};

export default NHISTermList;
